import { createPortal } from 'react-dom'

import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import useViewModel from './ViewModel'

const SaleOrderDetailView: React.FC = () => {
  const {
    modalsRoot,
    isOpenViewModal,
    handleClose,
  } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_sale_order_import'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-900px'
      show={isOpenViewModal}
      onHide={handleClose}
      backdrop={true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Sale Order Detail</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-500px'>
          <img src="/mock/sale-order-modal.jpg" alt="order" className="w-100" />
          </div>

        <div className='modal-footer'>
            <>
              <button className='btn btn-sm btn-light' onClick={handleClose}>
                Close
              </button>
           
            </>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default SaleOrderDetailView
